export const rootHeader = '#rootHeader';
export const rootMessageBox = '#rootMessageBox';
export const rootHeaderNavigation = '#rootHeaderNavigation';
export const rootHeaderTopBar = '#rootHeaderTopBar';
